/* ETQ FAQ accordion — one open at a time */
(function () {
  function init(root) {
    var items = root.querySelectorAll('.etq-faq__item');

    items.forEach(function (item) {
      if (item.dataset.faqBound) return;
      item.dataset.faqBound = '1';

      var btn = item.querySelector('.etq-faq__question');
      var answer = item.querySelector('.etq-faq__answer');

      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        // Close all others
        items.forEach(function (other) {
          if (other !== item) {
            other.classList.remove('is-open');
            var a = other.querySelector('.etq-faq__answer');
            if (a) a.style.maxHeight = null;
            other.querySelector('.etq-faq__question').setAttribute('aria-expanded', 'false');
          }
        });

        // Toggle this one
        if (isOpen) {
          item.classList.remove('is-open');
          answer.style.maxHeight = null;
          btn.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('is-open');
          answer.style.maxHeight = answer.scrollHeight + 'px';
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.etq-faq').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();